export const EntityFormsName = 'entityFormsComponent';
